import { useMemo } from 'react'
import { Column } from 'src/shared/components/Semantic/all'
import { Combobox } from 'src/shared/components/Combobox'
import { Label } from 'src/shared/components/ui/label'

const compositeValue = (vendor: string, printCode: string) =>
  JSON.stringify([vendor, printCode])

const parseCompositeValue = (value: string): [string, string] => {
  const [vendor, printCode] = JSON.parse(value) as [string, string]
  return [vendor, printCode]
}

export const OrphanDropdown = ({
  label,
  items,
  selectedVendor,
  selectedPrintCode,
  onSelect,
}: {
  label: string
  items: { vendor: string; print_code: string }[]
  selectedVendor: string | null
  selectedPrintCode: string | null
  onSelect: (vendor: string, printCode: string) => void
}) => {
  const options = useMemo(
    () =>
      items.map((item) => ({
        value: compositeValue(item.vendor, item.print_code),
        label: `${item.vendor} - ${item.print_code}`,
      })),
    [items]
  )

  const value =
    selectedVendor &&
    selectedPrintCode &&
    items.some(
      (i) => i.vendor === selectedVendor && i.print_code === selectedPrintCode
    )
      ? compositeValue(selectedVendor, selectedPrintCode)
      : ''

  return (
    <Column className="gap-1">
      <Label className="text-xs text-foreground/60 ml-1">
        {label} ({items.length})
      </Label>
      <Combobox
        value={value}
        onValueChange={(next) => {
          const [vendor, printCode] = parseCompositeValue(next)
          onSelect(vendor, printCode)
        }}
        options={options}
        placeholder="Select..."
        searchPlaceholder="Search..."
        emptyMessage="No results."
        buttonClassName="w-[300px] justify-between font-normal"
      />
    </Column>
  )
}
